import React, { useState } from 'react';
import { Button, DialogTitle, Drawer, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ReactComponent as FilterIcon } from '@assets/icons/filtersIcon.svg';
import { ReactComponent as ResetFiltersIcon } from '@assets/icons/resetFiltersIcon.svg';
import { LoadingButton } from '@mui/lab';
import { useStyles } from './BaseFiltersDrawer.styles';

interface Props {
  isLoading: boolean;
  filtersCount: number;
  onReset: () => void;
  children: React.ReactNode;
  renderDrawer?: boolean;
  headerExtra?: React.ReactNode;
}

export const BaseFiltersDrawer: React.FC<Props> = ({
  isLoading,
  filtersCount,
  onReset,
  children,
  renderDrawer = true,
  headerExtra,
}) => {
  const styles = useStyles();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const isFilterExist = filtersCount > 0;

  const ResetBtn = (
    <Button startIcon={<ResetFiltersIcon />} onClick={onReset} size="small">
      Reset all
    </Button>
  );

  return (
    <>
      <div className={styles.btnsContainer}>
        {headerExtra}
        <LoadingButton
          variant="contained"
          startIcon={<FilterIcon />}
          onClick={handleOpen}
          loading={isLoading}
          size="small"
        >
          Filters {isFilterExist && `: ${filtersCount}`}
        </LoadingButton>
        {isFilterExist && ResetBtn}
      </div>
      {renderDrawer && (
        <Drawer anchor="right" open={open} onClose={handleClose} keepMounted>
          <DialogTitle className={styles.title}>Filters {isFilterExist && ResetBtn}</DialogTitle>
          <IconButton
            aria-label="close"
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
          {children}
        </Drawer>
      )}
    </>
  );
};
